import React, { useEffect, useState } from 'react'
import { axiosGet } from '../../../util/api'
import { Layout } from '../../../components/Layout'
import { Link, useParams } from 'react-router-dom'
import { Models } from '../../../types/profile'
import { UpdatesTable } from './UpdatesTable'

export const AdminProfileDetail = () => {
    const { profile_id } = useParams()
    const [profile, setProfile] = useState<Models.Profile | null>(null)

    useEffect(() => {
        axiosGet('admin/profiles/' + profile_id)
            .then((r) => {
                setProfile(r.data)
            })
            .catch(() => {})
    }, [])

    if (!profile) {
        return null
    }

    return (
        <Layout
            primary={
                <span>
                    <Link to="/admin/users" className="text-lg font-bold">
                        Users
                    </Link>
                    <b className="text-lg">&nbsp;/&nbsp;</b>
                    <Link
                        to={`/admin/users/${profile.keys?.user_id}`}
                        className="text-lg font-bold"
                    >
                        {profile.keys?.user_id}
                    </Link>
                    <b className="text-lg">&nbsp; / {profile_id}</b>
                </span>
            }
        >
            <div className="bg-white p-3 border rounded-md mb-8">
                <div>
                    User Id:{' '}
                    <Link to={`/admin/users/${profile.keys?.user_id}`}>
                        {profile.keys?.user_id}
                    </Link>
                </div>
                <div>
                    Profile Id:{' '}
                    <Link to={`/admin/profiles/${profile.profile_id}`}>{profile.profile_id}</Link>
                </div>
                <div>Marketplace: {profile.marketplace_id}</div>
                <div>Name: {profile.keys?.user?.name}</div>
                <div>Email: {profile.keys?.user?.email}</div>
            </div>
            <UpdatesTable profile_id={parseInt(profile_id)} />
        </Layout>
    )
}
